import {doc} from './docs.js';

doc(
    "switch",
    {
        "switchNumber": ""
    },
    "switch inlets based on first inlet",
    undefined,
    {
        isHot: true,
        inlets: x => x + 1
    }
);

export const z_switch = (o, ...args) => {
    let lastIndex;
    let lastMsg;
    return ([msg]) => {
        let index = msg-1;
        if (args[index]) {
            let ret = args[index]();
            if (lastIndex !== index || lastMsg !== ret) {
                lastMsg = ret;
                lastIndex = index;
                return [ret];
            }
            lastMsg = ret;
            lastIndex = index;
        }
    };
};

doc(
    "outSwitch",
    {
        "switchNumber": ""
    },
    "switch inlets based on first inlet",
    (x) => x,
    {
        inlets: x => 2
    }
);

export const out_switch = (o, number) => {
    return ([msg]) => {
        let _num = number();
        let ar = new Array(_num).fill(undefined);
        ar[_num-1] = msg;
        return ar;
    };
};

